import { axiosInstance as axios } from "services";

export const fetchStaticAll = async () => {
  const { data } = await axios.get("/admin/static/all");
  if (!data.success) throw new Error(data.error || "Failed to fetch static data");
  return data;
};

